<ng-container *ngIf="bookingStore.loaded$ | async; else loader">
  <ng-container *ngIf="bookingStore.selectedPlan$ | async as selectedPlan">
    <ng-container *ngIf="selectedPlan === BookingPlans.Pro || selectedPlan === BookingPlans.Basic">
      <div class="checkout-wrapper">
        <div class="back-btn-wrapper">
          <button
            *ngIf="bookingStore.loaded$ | async"
            mat-raised-button
            gtm="onSelect"
            gtmAction="Booking Stepper"
            gtmCategory="booking"
            color="primary"
            (click)="onBack()"
            data-at-back-button
          >
            {{ 'GENERAL.BUTTON.BACK' | translate }}
          </button>
        </div>
        <div class="checkout-content">
          <div class="checkout-list-wrapper">
            <div class="checkout-list">
              <div class="checkout-header-wrapper">
                <h3 class="checkout-list-header">
                  <ng-container *ngIf="selectedPlan === BookingPlans.Basic">{{
                    '+COMMERCIAL_BOOKING.CHECKOUT.BASIC_LIST_DESCRIPTION' | translate
                  }}</ng-container>
                  <ng-container *ngIf="selectedPlan === BookingPlans.Pro">{{
                    '+COMMERCIAL_BOOKING.CHECKOUT.PRO_LIST_DESCRIPTION' | translate
                  }}</ng-container>
                </h3>
              </div>
              <div class="checkout-list-entry" data-at-installation>
                <p *ngIf="selectedPlan === BookingPlans.Basic">
                  {{ '+COMMERCIAL_BOOKING.CHECKOUT.BASIC_PACKAGE_DESCRIPTION' | translate }}
                </p>
                <p *ngIf="selectedPlan === BookingPlans.Pro">
                  {{ '+COMMERCIAL_BOOKING.CHECKOUT.PRO_PACKAGE_DESCRIPTION' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="checkout-summary-wrapper">
            <app-commercial-booking-summary data-at-checkout-section (continue)="onContinue()">
            </app-commercial-booking-summary>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loader>
  <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
</ng-template>
